import classnames from "classnames";
import PropTypes from "prop-types";
import { memo } from "react";

const Shelter4uSVgIcon = memo(({ width = "110", height = "120", className, pathClassName }) => {
  return (
    <>
      <style>
        {`
          /* Hardware Accelerated Animation */
          @keyframes s4u-draw-loop-optimized {
            0% { 
              stroke-dashoffset: 300; 
              opacity: 0; 
            }
            10% { 
              opacity: 1; 
            }
            35% { 
              stroke-dashoffset: 0; 
            }
            85% { 
              stroke-dashoffset: 0; 
              opacity: 1; 
            }
            100% { 
              stroke-dashoffset: 0; 
              opacity: 0; 
            }
          }
        `}
      </style>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 110 120"
        width={width}
        height={height}
        fill="none"
        className={classnames(className)}
        style={{ display: "block" }} // Prevents layout shifts
      >
        <path
          className={pathClassName}
          d="M 80 105 L 80 55 L 40 55 L 95 15"
          stroke="#DA291C"
          strokeWidth="22"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            strokeDasharray: 300,
            strokeDashoffset: 300,
            // 'will-change' tells the browser to optimize for this specific property
            willChange: "stroke-dashoffset, opacity",
            animation: "s4u-draw-loop-optimized 5s ease-in-out infinite",
          }}
        />
      </svg>
    </>
  );
});

Shelter4uSVgIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  pathClassName: PropTypes.string,
};

export default Shelter4uSVgIcon;
